export const sellerEmails = ["devs4oryou@gmail.com"];
export const days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
export const months = ["Януари", "Февруари", "Март", "Април", "Май", "Юни", "Юли", "Август", "Септември", "Октомври", "Ноември", "Декември"];
export const years = [2023, 2024, 2025, 2026];

// BGN to EUR conversion rate (fixed rate: 1 EUR = 1.95583 BGN)
export const BGN_TO_EUR_RATE = 1.95583;

// Number formatter for 2 decimal places
const numberFormatter = new Intl.NumberFormat("bg-BG", {
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
});

// Helper function to format dual currency display
export const formatDualCurrency = (bgnValue: number | undefined | null): string => {
	if (bgnValue === undefined || null === bgnValue) {
		return "";
	}
	const eurValue = bgnValue / BGN_TO_EUR_RATE;
	return `${numberFormatter.format(eurValue)}€ / ${numberFormatter.format(bgnValue)}лв`;
};

export const eurToBgn = (eurValue: number | undefined | null | string): number => {
	if (undefined === eurValue || null === eurValue || "" === eurValue) {
		return 0;
	}
	const numValue = Number(eurValue);
	if (isNaN(numValue)) {
		return 0;
	}
	// Round to 2 decimal places without using formatter (which adds locale-specific formatting)
	return Number(eurValue) * BGN_TO_EUR_RATE;
};
